<template>
  <div>
    <v-text-field
      v-if="item.typ === 'text'"
      :label="item.text"
      :maxlength="item.maxlength"
      :value="value"
      @input="updateValue"
      :disabled="!editable"
      clearable
    />
    <base-date-input
      v-if="item.typ === 'datetime'"
      :item="item"
      :value="value"
      @input="updateValue"
      :editable="editable"
    />
    <v-checkbox
      v-if="item.typ === 'boolean'"
      :value="value"
      :input-value="value"
      @change="updateValue"
      :label="item.text"
    ></v-checkbox>
    <v-text-field
      v-if="item.typ === 'number'"
      :label="item.text"
      :value="value"
      @input="updateValue"
      type="number"
      :disabled="!editable"
      clearable
    ></v-text-field>
    <v-textarea
      v-if="item.typ === 'textarea'"
      :label="item.text"
      :value="value"
      @input="updateValue"
      :disabled="!editable"
      rows="3"
    ></v-textarea>
  </div>
</template>

<script>
import BaseDateInput from "./BaseDateInput.vue"

export default {
  name: "MeranieDialogItem",
  props: {
    typ: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    meranie: {
      type: Object,
      required: true
    },
    value: {
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: { BaseDateInput },
  data: function() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    updateValue: function(value) {
      if (this.item.typ === "number") {
        console.log("updateValue number", value)
        if (value === null) {
          value = null
        } else {
          value = Number(value)
        }
      }
      this.$emit("input", value)
    },
    updateValueOnClick: function(e) {
      console.log("updateValueOnClick", e, this.value)
      //this.$emit("input", this.value)
    }
  }
}
</script>
